import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { UserRoundMinus, UserRoundPlus } from 'lucide-react'
import { tr } from 'i18n'
import { hasAccess } from 'utils/access'
import { getErpErrorMessage } from 'service/ErpService'
import DriverAssignmentDialog from '../DriverAssignmentDialog/DriverAssignmentDialog.tsx'
import s from '../Management.module.scss'
import './DriverAssignmentActions.scss'

export default function DriverAssignmentActions({ driver, onChanged = () => {}, showAvailabilityHint = true }: any) {
  useTranslation()
  const user = useSelector((state: any) => state.user)
  const [mode, setMode] = useState('')
  const [busy, setBusy] = useState(false)
  const busyRef = useRef(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  if (!hasAccess(user, 'drivers_assign')) return null
  const available = ['', 'Свободен', 'Простаивает', 'free', 'idle'].includes(driver.status || '') && !driver.integration_active_load
  const run = async (operation: () => Promise<any>) => {
    if (busyRef.current) return
    busyRef.current = true
    setBusy(true); setError(''); setMessage('')
    try {
      await operation()
      setMessage(tr(mode === 'release' ? 'Водитель освобождён от транспорта.' : 'Водитель назначен на транспорт.'))
      setMode('')
      await onChanged()
    } catch (failure) { setError(getErpErrorMessage(failure)) }
    finally { busyRef.current = false; setBusy(false) }
  }
  return <div className="driver-assignment-actions" onClick={event => event.stopPropagation()}>
    <div className={s.actions}>
      <button className={s.button} disabled={!available || busy} onClick={() => { setError(''); setMessage(''); setMode('assign') }}>
        <UserRoundPlus size={14} aria-hidden="true" />{tr(driver.employee === null ? 'Назначить водителя' : 'Сменить водителя')}
      </button>
      {driver.employee !== null && <button className={s.button} disabled={!available || busy}
        onClick={() => { setError(''); setMessage(''); setMode('release') }}>
        <UserRoundMinus size={14} aria-hidden="true" />{tr('Освободить водителя')}
      </button>}
    </div>
    {showAvailabilityHint && !available && <p className={s.muted}>{tr('Смена водителя, работа с базой, доступна, когда транспорт свободен или простаивает.')}</p>}
    {message && <p role="status" className={s.muted}>{message}</p>}
    {!mode && error && <p role="alert" className={s.error}>{tr(error)}</p>}
    {mode && <DriverAssignmentDialog driver={driver} mode={mode} busy={busy} error={error}
      onClose={() => { if (!busyRef.current) setMode('') }} onRun={run} />}
  </div>
}
